<template>
  <div>
    <v-row>
      <v-col cols="12" md="4">
        <last-reminders></last-reminders>
      </v-col>
      <v-col cols="12" md="4">
        <active-users></active-users>
      </v-col>
      <v-col cols="12" md="4">
        <SCalendar class="pa-3"></SCalendar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <posted-notifications></posted-notifications>
      </v-col>
      <v-col cols="12" md="6">
        <received-notifications></received-notifications>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import PostedNotifications from "@/views/modulePages/basicInformation/PostedNotifications";
import ReceivedNotifications from "@/views/modulePages/basicInformation/ReceivedNotifications";
import LastReminders from "@/views/modulePages/basicInformation/LastReminder";
import ActiveUsers from "@/views/modulePages/basicInformation/ActiveUsers";
import SCalendar from "@/views/modulePages/basicInformation/SCalendar";

export default {
  name: "BasicInformation",
  components: {
    SCalendar,
    ActiveUsers,
    LastReminders,
    ReceivedNotifications,
    PostedNotifications
  },
  props: {
    id: {},
  },
  data() {
    return {
    }
  },
}
</script>

<style scoped lang="scss"></style>

